import React from 'react';
import PropTypes from 'prop-types';

import Typography from 'components/ui-kit/typography';
import Money from 'components/ui-kit/money';

import { depositAmountTypes } from 'helpers/enums';

import * as S from './styles';

const DepositDueSection = ({
  amount, total, amountType, rawAmount, pendingCredit,
}) => {
  const isPercent = amountType === depositAmountTypes.percent;
  const remaining = Math.max(total - amount, 0);

  return (
    <S.Box>
      <S.Row>
        <Typography color="dark" bold fluidFont={{ min: 12, max: 14 }}>
          {`Deposit due${isPercent ? ` (${rawAmount}%)` : ''}`}
        </Typography>

        <Typography color="dark" bold fluidFont={{ min: 12, max: 14 }}>
          <Money amount={amount} />
        </Typography>
      </S.Row>

      <S.Row>
        <Typography color="primary" fluidFont={{ min: 11, max: 13 }}>
          Remaining balance
        </Typography>

        <Typography color="primary" fluidFont={{ min: 11, max: 13 }}>
          <Money amount={remaining} />
        </Typography>
      </S.Row>

      {pendingCredit > 0 && (
        // Credit never pays a deposit (same rule the backend enforces before charging it), so without
        // this note the customer's credit balance - visible on their Profile page - would just silently
        // not show up here, reading as a bug rather than the deliberate rule it is.
        <S.Row>
          <Typography color="primary" fluidFont={{ min: 11, max: 13 }}>
            {'Your '}
            <Money amount={pendingCredit} />
            {' credit will be applied to the remaining balance, after the deposit'}
          </Typography>
        </S.Row>
      )}
    </S.Box>
  );
};

DepositDueSection.propTypes = {
  amount: PropTypes.number.isRequired,
  total: PropTypes.number.isRequired,
  amountType: PropTypes.number,
  rawAmount: PropTypes.number,
  pendingCredit: PropTypes.number,
};

DepositDueSection.defaultProps = {
  amountType: null,
  rawAmount: null,
  pendingCredit: 0,
};

export default DepositDueSection;
